var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Menu-item",class:{ active: _vm.active == _vm.route },on:{"click":_vm.click}},[_c('a',[_c('img',{attrs:{"src":_vm.image}}),_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }